import type { Banner, BannerType, BannerFilters, DeviceType } from '../types';
import { useBannersStore } from '@/stores';
import { useToast } from 'primevue/usetoast';
import { computed, ref, watch } from 'vue';
import i18n from '@/plugins/i18n';
export function useBanners(bannerType: BannerType) {
    const bannersStore = useBannersStore();
    const toast = useToast();
    const banners = computed<Banner[]>(() => bannersStore.banners[bannerType]);
    const loadingFlag = ref<boolean>(false);
    const toastText = 'get_banners';

    const toSetRequest = async (type: BannerType): Promise<void> => {
        loadingFlag.value = true;
        const filters: BannerFilters = {
            banner_type: type,
            language_code: i18n.global.locale.value,
            device_type: deviceType.value
        };
        try {
            await bannersStore.awaitGetBanners(filters);
        } catch (error) {
            toast.add({
                severity: 'error',
                group: 'global',
                summary: toastText,
                detail: String(error),
                life: 4000
            });
        } finally {
            loadingFlag.value = false;
        }
    };
    const deviceType = computed<DeviceType>(() => {
        const width = window.innerWidth;
        if (width >= 1024) {
            return 'PC';
        } else if (width >= 481 && width < 1024) {
            return 'Tablet';
        } else {
            return 'Mobile';
        }
    });
    watch(
        banners,
        (newV) => {
            if (!newV) {
                toSetRequest(bannerType);
            }
        },
        {
            deep: true
        }
    );
    return {
        banners,
        loadingFlag,
        toSetRequest
    };
}
